import React from "react";
import { observer, inject } from "mobx-react";
import * as M from "@material-ui/core";
import * as yup from "yup";
import { Formik, Field, Form } from "formik";

const UserRegister = ({ store }) => {
  const { $user, $config, $locale } = store;

  let validationSchema = yup.object().shape({
    email: yup.string().required("Dit veld is verplicht").email("Foutieve emailnotatie"),
    password: yup.string().required("Dit veld is verplicht").min(6, "Minimum 6 tekens"),
    password_confirm: yup.string().oneOf([yup.ref("password"), null], "Wachtwoord is niet gelijk"),
    ...($config.register_as_group &&
      !$config.register_as_individual && { group: yup.string().required("Dit veld is verplicht") })
  });

  return (
    <M.Dialog open={$user.enableRegister} onClose={() => $user.change("enableRegister", false)}>
      <M.DialogTitle>{$locale.t("register_register_title")}</M.DialogTitle>
      {$user.registerStep === "register" && (
        <Formik
          initialValues={{
            email: "",
            password: "",
            password_confirm: "",
            group: "",
            brugFiguur: false,
            educationLevel: ""
          }}
          validationSchema={validationSchema}
          onSubmit={async (data, { setSubmitting }) => {
            setSubmitting(true);
            const response = await $user.register({
              email: data.email,
              password: data.password,
              ...(data.group && { group: data.group }),
              ...(data.brugFiguur && { brugFiguur: data.brugFiguur }),
              ...(data.educationLevel && { educationLevel: data.educationLevel }),
              cluster: $user.registerForCluster
            });
            if (response) {
              $user.change("registerStep", "register_success");
            }
            setSubmitting(false);
          }}
        >
          {({ values, errors, touched, isSubmitting, handleChange }) => (
            <Form name="user-register" className="w-full" noValidate>
              <M.DialogContent>
                <div
                  className="my-4"
                  dangerouslySetInnerHTML={{
                    __html: $locale.t("register_register_body")
                  }}
                />
                <div className="mb-2">
                  <Field
                    error={!!(touched.email && errors.email)}
                    required
                    fullWidth
                    label="Uw emailadres"
                    type="email"
                    name="email"
                    helperText={touched.email && errors.email}
                    as={M.TextField}
                  />
                </div>
                <div className="mb-2 grid grid-cols-12 gap-4">
                  <div className="col-span-6">
                    <Field
                      error={!!(touched.password && errors.password)}
                      fullWidth
                      required
                      label="Wachtwoord"
                      type={"password"}
                      name="password"
                      placeholder="minimum 6 tekens"
                      helperText={touched.password && errors.password}
                      as={M.TextField}
                    />
                  </div>
                  <div className="col-span-6">
                    {values.password_confirm.error && "error"}
                    <Field
                      error={!!(touched.password_confirm && errors.password_confirm)}
                      fullWidth
                      required
                      label="Bevestig wachtwoord"
                      type={"password"}
                      name="password_confirm"
                      helperText={touched.password_confirm && errors.password_confirm}
                      as={M.TextField}
                    />
                  </div>
                </div>
                {$config.register_as_group && (
                  <div className="mb-2">
                    {$config.id === "barometer-disco" && (
                      <div className="mb-2">{$locale.t("register_register_group_description")}</div>
                    )}
                    <Field
                      label={$locale.t("group_name") || "Groepsnaam"}
                      error={!!(touched.group && errors.group)}
                      placeholder={$locale.t("group_name") || "Bv. naam van school, campus, ... "}
                      fullWidth
                      name="group"
                      required={$config.register_as_group && !$config.register_as_individual}
                      helperText={touched.group && errors.group}
                      as={M.TextField}
                    />
                  </div>
                )}
                {$config.id === "obs-barometer" && (
                  <React.Fragment>
                    <div className="mb-2">
                      <M.TextField
                        select
                        label="Onderwijsniveau"
                        error={!!(touched.educationLevel && errors.educationLevel)}
                        value={values.educationLevel}
                        fullWidth
                        onChange={handleChange}
                        name="educationLevel"
                      >
                        {[
                          { label: "Basisonderwijs", value: "basis" },
                          {
                            label: "Secundair onderwijs",
                            value: "secundair"
                          }
                        ].map(option => (
                          <M.MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </M.MenuItem>
                        ))}
                      </M.TextField>
                    </div>
                    <div className="my-2">
                      <M.FormControlLabel
                        control={
                          <M.Checkbox
                            name="brugFiguur"
                            checked={values.brugFiguur}
                            onChange={handleChange}
                          />
                        }
                        label="Deze school heeft een brugFiguur"
                      />
                    </div>
                  </React.Fragment>
                )}
                <br />
              </M.DialogContent>
              <M.DialogActions>
                <M.Button variant="outlined" onClick={() => $user.change("enableRegister", false)}>
                  {$locale.t("cancel")}
                </M.Button>
                <M.Button type="submit" disabled={isSubmitting}>
                  {$locale.t("register_register_btn_label")}
                </M.Button>
              </M.DialogActions>
            </Form>
          )}
        </Formik>
      )}

      {$user.registerStep === "register_success" && (
        <React.Fragment>
          <M.DialogContent>
            <div className="my-4">{$locale.t("register_success_text")}</div>
          </M.DialogContent>
          <M.DialogActions>
            <M.Button onClick={() => $user.change("enableRegister", false)}>OK</M.Button>
          </M.DialogActions>
        </React.Fragment>
      )}
    </M.Dialog>
  );
};

export default inject("store")(observer(UserRegister));

// const useField = (defaultValue) => {
//   const [value, setValue] = React.useState(defaultValue);
//   const [dirty, setDirty] = React.useState(false);
//   const [touched, setTouched] = React.useState(false);
//   const [error, setError] = React.useState(false);

//   async function handleChange(e) {
//     setValue(e.target.value);
//     const valid = await schema.isValid({
//       [e.target.name]: e.target.value,
//     });
//     !valid ? setError("Geen geldig e-mailadres") : setError(false);
//     setDirty(true);

//     schema
//       .validate({
//         email: "email",
//         password: "dddddd",
//         password_confirm: "dddddd",
//       })
//       .catch(function (err) {
//         console.log(err);
//       });
//   }

//   function handleBlur(e) {
//     setTouched(true);
//   }

//   return {
//     value,
//     setValue,
//     dirty,
//     setDirty,
//     touched,
//     setTouched,
//     error,
//     setError,
//     handleChange,
//     handleBlur,
//   };
// };
